<ng-container *ngFor="let field of params.fields;">

  <div class="field-row" [ngStyle]="field.containerStyle" *ngIf="field._isVisible" >
    <ng-container
      [service]="service"
      [field]="field"
      [group]="form"
      gioFormField>
    </ng-container>
  </div>


</ng-container>
